import moment from "moment";

export const formatPeriodDay = (d?: string) =>
  d && moment.utc(d).isValid() ? moment.utc(d).format("MM/DD/YYYY") : "";

export const formatInvoicePeriod = (start?: string, end?: string) => {
  const parts = [formatPeriodDay(start), formatPeriodDay(end)].filter(Boolean);
  return parts.length ? parts.join(" – ") : "—";
};
